import React from "react";
import Loader from "../ui/Loader";

const CommonHeadingNBtns = ({
  title,
  onClose,
  onClick,
  onClickBack,
  isLoading,
  btnTxt,
  backBtnTxt,
  noBtnTxt,
  isDisabled,
  isViewBtn,
  btnTxt1,
  onClick1,
  onClickViewBtn,
}) => {
  return (
    <div className="modalHeadAndCloseContainer doubleBtns">
      <h2 className="titleHead">{title}</h2>

      <div className="flexEnd">
        {onClose && (
          <button
            type="button"
            className="btn btn-outline-dark"
            onClick={onClose}>
            Close
          </button>
        )}

        {isLoading ? (
          <Loader />
        ) : (
          <>
            {backBtnTxt ? (
              <button
                type="button"
                className="btn btn-danger btn-back"
                style={{ background: "#3D3B40", border: "none" }}
                onClick={onClickBack}>
                {backBtnTxt}
              </button>
            ) : null}

            {!noBtnTxt && onClick ? (
              <button
                type="button"
                className="btn btn-danger btn-save"
                onClick={onClick}
                disabled={isDisabled}>
                {btnTxt ? btnTxt : "Save"}
              </button>
            ) : null}

            {btnTxt1 && onClick1 ? (
              <button
                type="button"
                className="btn btn-danger btn-save"
                style={{ background: "#000", border: "1px solid #000" }}
                onClick={onClick1}
                disabled={isDisabled}>
                {btnTxt1}
              </button>
            ) : null}
          </>
        )}

        {isViewBtn && onClickViewBtn ? (
          <button
            type="button"
            className="btn btn-danger btn-back"
            style={{ background: "#3D3B40", border: "none" }}
            onClick={onClickViewBtn}
            disabled={isDisabled}>
            {isViewBtn}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default CommonHeadingNBtns;